module.exports = __webpack_public_path__ + "img/video6.50c5a2b7.png";